import { useState, useEffect, useRef } from "react";
//import NutritionAfterDescription from "../elements/nutrition/nutrition-after-description";
//import PromoAboveAddToCart from "../elements/promo-add-to-cart/promo-add-to-cart";
//import ShippingMessageAboveAddToCart from "../elements/shipping-message-add-to-cart/shipping-message-add-to-cart";


import dynamic from "next/dynamic";

// These will only load in the browser, never during SSR/build
const PromoAboveAddToCart = dynamic(
  () => import("../elements/promo-add-to-cart/promo-add-to-cart"),
  { ssr: false }
);

const ShippingMessageAboveAddToCart = dynamic(
  () => import("../elements/shipping-message-add-to-cart/shipping-message-add-to-cart"),
  { ssr: false }
);

const NutritionAfterDescription = dynamic(
  () => import("../elements/nutrition/nutrition-after-description"),
  { ssr: false }
);

export default function ProductBrowser({ onPageChange, storeId = 13433173 }) {
    const [labelIndex, setLabelIndex] = useState(new Map());
    const [productMap, setProductMap] = useState(new Map());
    const [row, setRow] = useState(null);
    const [ecwidLoaded, setEcwidLoaded] = useState(false);
    const [nutritionLoaded, setNutritionLoaded] = useState(false);


    const labelIndexRef = useRef(labelIndex);
    const productMapRef = useRef(productMap);
    const lastPageRef = useRef(null);
    const onPageChangeRef = useRef(onPageChange);

    useEffect(() => { labelIndexRef.current = labelIndex; }, [labelIndex]);
    useEffect(() => { productMapRef.current = productMap; }, [productMap]);
    useEffect(() => { onPageChangeRef.current = onPageChange; }, [onPageChange]);

    useEffect(() => {
        if (lastPageRef.current) onEcwidLoaded(lastPageRef.current);
    }, [labelIndex, productMap]);


    const loadJSON = async (url) => {
        const res = await fetch(url, { credentials: "same-origin" });
        if (!res.ok) throw new Error(`Fetch ${url} failed: ${res.status}`);
        return res.json();
    }

    function buildLabelIndex(list) {
        const arr = Array.isArray(list) ? list : (list?.items || []);
        const map = new Map();
        arr.forEach(row => {
            const rid = String(row["Recipe ID"] ?? row.recipeId ?? "").trim();
            if (rid) map.set(rid, row);
        });
        return map;  
    }

    function buildMap(objOrArr) {
        if (!objOrArr) new Map();
        if (Array.isArray(objOrArr)) return new Map(objOrArr.map(m => [String(m.productId), String(m.recipeId)]));
        if (typeof objOrArr === "object") return new Map(Object.entries(objOrArr).map(([k, v]) => [String(k), String(v)]));
        return new Map();
    }

    function onEcwidLoaded(page) {
        onPageChangeRef.current?.(page || null);

        if (page?.type === "PRODUCT") {
            const pid = String(page.productId || (location.href.match(/p(\d+)/) || [])[1] || "");
            const rid = productMap?.get(pid) || null;
            setRow(rid && labelIndex?.get(rid) ? labelIndex.get(rid) : null);
        } else {
            setRow(null);
        }

        lastPageRef.current = page || null;
        if (page?.type === "PRODUCT") {
            const pid = String(page.productId ?? (location.href.match(/p(\d+)/) || [])[1] ?? "");
            const rid = productMapRef.current.get(pid) || null;
            const r = rid ? labelIndexRef.current.get(rid) : null;
            setRow(r || null);
        } else {
            setRow(null);
        }

    }

    function onEcwidApiLoaded() {
        if (!ecwidLoaded) {
            xProductBrowser("categoriesPerRow=3", "views=grid(3,3) list(10) table(20)", "categoryView=grid", "searchView=list", "id=ecStoreProductBrowser");
            setEcwidLoaded(true);
        }
    }

    async function init() {
        if (nutritionLoaded) return;
        try {
            const labels = await loadJSON("/nutrition/label_data.json");
            const labelIndex = buildLabelIndex(labels);
            setLabelIndex(labelIndex);

            let mapJson = null;
            let productMap = null;
            try {
                mapJson = await loadJSON("/nutrition/product_recipe_map.json");
                productMap = buildMap(mapJson);
                setProductMap(productMap);
                //  setNutritionLoaded(true);
            } catch { /* it's fine if the file doesn't exist */ }

            if (mapJson && productMap) setNutritionLoaded(true)

            // Attach Ecwid listener (retry in case widget script hasn't initialized yet)
            const attach = () => {
                if (!window.Ecwid) return false;
                let attached = false;

                if (window.Ecwid?.OnPageLoaded?.add) {
                    window.Ecwid.OnPageLoaded.add(onEcwidLoaded);
                    onEcwidLoaded(window.Ecwid.getLastPage?.() || {}); // run once
                    attached = true;
                }

                if (window.Ecwid?.OnAPILoaded?.add) {
                    window.Ecwid.OnAPILoaded.add(onEcwidApiLoaded);
                    onEcwidApiLoaded();
                    attached = true;
                }

                if (attached) console.log('Ecwid listeners successfully attached');
                return attached;
            };
            let attached = attach();
            if (!attached) {
                const t = setInterval(() => {
                    //const a = attach();
                    if (attach()) clearInterval(t);
                }, 200);
                setTimeout(() => clearInterval(t), 10000);
            }

        } catch (e) {
            console.warn("Nutrition init failed:", e);
        }
    }

    function configureEcwid() {
        window.ec = window.ec || {};
        window.ec.config = window.ec.config || {};
        window.ec.config.storefrontUrls = window.ec.config.storefrontUrls || {};
        window.ec.config.storefrontUrls.cleanUrls = true;
        window.ec.config.baseUrl = '/store';

        window.ecwid_script_defer = true;
        window.ecwid_dynamic_widgets = true;
    }


    useEffect(() => {
        if (typeof window === "undefined") return;

        configureEcwid();

        if (!document.getElementById('ecwid-script')) {
            var script = document.createElement('script');
            // script.charset = 'utf-8';
            script.type = 'text/javascript';
            script.src = 'https://app.ecwid.com/script.js?' + storeId + '&data_platform=nextjs';
            script.id = 'ecwid-script'
            script.onload = init
            document.body.appendChild(script);
        } else {
            // load_ecwid()
            if (!nutritionLoaded) {
                init();
            }
        }

        return () => {
            try {
                window.Ecwid?.OnPageLoaded?.remove?.(onEcwidLoaded);
                window.Ecwid?.OnAPILoaded?.remove?.(onEcwidApiLoaded);
            } catch { }
        };
    }, []); // [labelIndex, productMap, storeId, ecwidLoaded]);

    return (
        <>
            <div id="ecStoreProductBrowser">{/* Your Ecwid widget embed/script goes here */}</div>
            <NutritionAfterDescription row={row} />
            <ShippingMessageAboveAddToCart  />
            {/* <PromoAboveAddToCart  /> */}
        </>
    );
}
